import * as React from 'react'
import UIMessages from 'src/utils/ui-messages'
import Modal from '../ui/Modal'

export interface IDeleteSessionProps {
  onClose: any
  onDelete: any
  message: string
  disableDeleteButton: boolean
}

class SessionHistoryDeleteSessionModal extends React.Component<IDeleteSessionProps> {
  constructor(props: IDeleteSessionProps) {
    super(props)
  }

  public render() {
    const classForDisabled = this.props.disableDeleteButton ? 'bg-grey' : 'bg-red'
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center'>
          <div className='med-modal'>
            <span className='ModalAddTitle font-small weight-300 font-grey2 uppercase'>DELETE SESSION</span>
            <div className='mt1 border-top pt2'>
              {/* {this.props.message === UIMessages.driver.deleteModalMessage && ( */}
              <div className='font-grey3 h5'>
                {' '}
                Deleting a driver's session for a selected day may cause the driver's trips for the day to not show in
                the table.
              </div>
              {/* )} */}
              <span className='font-grey3 h5'>{this.props.message}</span>
            </div>
            <div className='flex items-center justify-end mt3'>
              <button type='button' onClick={this.props.onClose} className='CancelButton custom-btn mbsc-clear-btn'>
                {UIMessages.common.cancel}
              </button>
              <button
                disabled={this.props.disableDeleteButton}
                type='button'
                onClick={this.props.onDelete}
                className={'SubmitButton ' + classForDisabled + ' custom-btn mbsc-red-btn ml1'}
              >
                {UIMessages.common.deleteLabel}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

export default SessionHistoryDeleteSessionModal



// WEBPACK FOOTER //
// ./src/components/drivers/SessionHistoryDeleteSessionModal.tsx